export default __webpack_public_path__ + "static/media/icon-linkedin.2cad1ba9.webp";